import { render, staticRenderFns } from "./peopleInfo.vue?vue&type=template&id=421db7ba&scoped=true"
import script from "./peopleInfo.vue?vue&type=script&lang=js"
export * from "./peopleInfo.vue?vue&type=script&lang=js"
import style0 from "./peopleInfo.vue?vue&type=style&index=0&id=421db7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421db7ba",
  null
  
)

export default component.exports